import { render } from "./dermatology_prescriptions.vue?vue&type=template&id=f4618438&scoped=true"
import script from "./dermatology_prescriptions.vue?vue&type=script&lang=js"
export * from "./dermatology_prescriptions.vue?vue&type=script&lang=js"

import "./dermatology_prescriptions.vue?vue&type=style&index=0&id=f4618438&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4618438"]])

export default __exports__